import React, { ReactNode } from 'react';
import './ServiceRequestTotal.scss';

const ServiceRequestTotalContent = ({ children }: { children: ReactNode }) => (
  <div className="service-request-total--container">
    <div className="service-request__total">
      <div className="service-request__total-text">Total</div>
      <div className="service-request__total-amount">{children}</div>
    </div>
  </div>
);

export default ServiceRequestTotalContent;
